module.exports = __webpack_public_path__ + "media/images/admin/undraw_blank_canvas_re_2hwy-0a4ddf8fbab156d75b8e18a704abd1b6.svg";